export default function calculateTotalBudgetAmount() {
  return () => Promise.resolve({
    status: true,
  });
}
